import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnInit,
} from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { USERTYPE } from "src/app/core/enums/routing-item.enum";
import { GSL_INFO } from "src/app/shared/enums/data-mock-enums";
import { MESSAGE_TOAST } from "src/app/shared/enums/message-toast-enum";
import { PATH_ROUTING } from "src/app/shared/enums/routing-enums";
import { UserSupplierService } from "src/app/shared/service/user-supplier.service";
import { SrmService } from "src/app/shared/service/srm.service";
import { Spinner } from "../../../../../../core/services/spinner.service";
import { CustomValidator } from "../../../../../../shared/directive/custom-validator";
export class GSLModel {
  gslNumber: string;
  supplierName: string;
  parentCompanyName: string;
  isEdit: boolean;

  constructor(
    gslNumber: string,
    supplierName: string,
    parentCompanyName: string,
    isEdit: boolean,
  ) {
    this.gslNumber = gslNumber;
    this.supplierName = supplierName;
    this.parentCompanyName = parentCompanyName;
    this.isEdit = isEdit;
  }
}

export class EOLModel {
  gslNumber: string;
  supplierName: string;
  supplierType: string;
  isEdit: boolean;

  constructor(
    gslNumber: string,
    supplierName: string,
    supplierType: string,
    isEdit: boolean,
  ) {
    this.gslNumber = gslNumber;
    this.supplierName = supplierName;
    this.supplierType = supplierType;
    this.isEdit = isEdit;
  }
}

@Component({
  selector: "app-create-edit-supplier-user",
  templateUrl: "./create-edit-supplier-user.component.html",
  styleUrls: ["./create-edit-supplier-user.component.scss"],
})
export class CreateEditSupplierUserComponent implements OnInit, AfterViewInit {
  isEdit = false;
  supplierForm: FormGroup;
  listInfo: any[] = [];
  listEOLInfo: any[] = [];
  supplierId: string;
  supplierModel: any = {};
  type = "external_supplier";
  isInternal = false;
  options: string[] = ["One", "Two", "Three"];
  isSubmit = false;
  listGSLNumber = [];
  listSupplierName = [];
  listParentCompanyName = [];
  listEOLGSLNumber = [];
  listEOLSupplierName = [];
  listSupplierType = [];
  eolSupplierNameOptions: string[] = [];
  eolSupplierData: any[] = [];
  listSiteNumber = [];
  gslInfo: any[] = [];
  eolInfo: any[] = [];

  constructor(
    private spinner: Spinner,
    private userSupplierService: UserSupplierService,
    private srmService: SrmService,
    private toastr: ToastrService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef,
  ) {
    this.activatedRoute.data.subscribe((res) => {
      if (res.type === USERTYPE.INTERNAL_USER) {
        this.type = USERTYPE.INTERNAL_USER;
        this.isInternal = true;
      }
    });
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe((res) => {
      if (res.id) {
        this.supplierId = res.id;
        this.isEdit = true;
        this.getSupplierById(this.type, this.supplierId);
      }
    });
    this.listInfo.push(new GSLModel("", "", "", true));
    this.listEOLInfo.push(new EOLModel("", "", "", true));
    this.initForm();
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  public initForm(model?) {
    if (model) {
      this.supplierForm = new FormGroup({
        sso: new FormControl(model.sso, [CustomValidator.required]),
        fullName: new FormControl(model.fullName),
        email: new FormControl(model.email),
        rspAccess: new FormControl(model.rspAccess),
      });
    } else {
      this.supplierForm = new FormGroup({
        sso: new FormControl("", [CustomValidator.required]),
        fullName: new FormControl(""),
        email: new FormControl(""),
        rspAccess: new FormControl(false),
      });
    }
  }

  public submit() {
    this.isSubmit = true;
    if (this.supplierForm.invalid) {
      this.markFormGroupTouched(this.supplierForm);
      return;
    }
    if (this.checkRequiredGSLInfo(this.listInfo) && !this.isInternal) {
      this.toastr.error(MESSAGE_TOAST.GSL_INFO_REQUIRED);
      return;
    }
    if (
      this.checkDifferentParentCompantName(this.listInfo) &&
      !this.isInternal
    ) {
      this.toastr.error(MESSAGE_TOAST.GSL_DIFFERENT_COMPANY_NAME);
      return;
    }
    if (this.checkDuplicateGSLInfo(this.listInfo) && !this.isInternal) {
      this.toastr.error(MESSAGE_TOAST.GSL_DUPLICATED_INFO);
      return;
    }
    if (this.checkRequiredEOLInfo(this.listEOLInfo) && !this.isInternal) {
      this.toastr.error(MESSAGE_TOAST.GSL_INFO_REQUIRED);
      return;
    }
    if (this.checkDifferentSupplierType(this.listEOLInfo) && !this.isInternal) {
      this.toastr.error(MESSAGE_TOAST.GSL_DIFFERENT_SUPPLIER_TYPE);
      return;
    }
    if (this.checkDuplicateEOLInfo(this.listEOLInfo) && !this.isInternal) {
      this.toastr.error(MESSAGE_TOAST.GSL_DUPLICATED_INFO);
      return;
    }

    const requestModel = {
      id: this.supplierModel.id,
      sso: this.supplierForm.controls.sso.value,
      email: this.supplierForm.controls.email.value,
      fullName: this.supplierForm.controls.fullName.value,
      rspAccess: this.supplierForm.controls.rspAccess.value,
      gslInfos: this.listInfo,
      eolInfos: this.listEOLInfo.map((item) => ({
        supplierForm: item.supplierForm || null,
        isEdit: item.isEdit 
      })),
    };
    this.spinner.show();
    if (!this.isEdit) {
      this.userSupplierService
        .addNewSupplier(requestModel, this.type)
        .subscribe((res) => {
          this.spinner.hide();
          if (res.status === 200) {
            if (this.isInternal) {
              this.toastr.success(MESSAGE_TOAST.ADD_INTERNAL_USER_SUCCESS);
              this.router.navigate([
                PATH_ROUTING.PATH_SRM,
                PATH_ROUTING.PATH_ADMIN,
                PATH_ROUTING.PATH_INTERNAL_USER,
              ]);
            } else {
              this.toastr.success(MESSAGE_TOAST.ADD_SUPPLIER_SUCCESS);
              this.router.navigate([
                PATH_ROUTING.PATH_SRM,
                PATH_ROUTING.PATH_ADMIN,
                PATH_ROUTING.PATH_SUPPIER_USER,
              ]);
            }
          }
        });
    } else {
      this.userSupplierService
        .updateSupplier(requestModel, this.type)
        .subscribe((res) => {
          this.spinner.hide();
          if (res.status === 200) {
            if (this.isInternal) {
              this.toastr.success(MESSAGE_TOAST.EDIT_INTERNAL_USER_SUCCESS);
              this.router.navigate([
                PATH_ROUTING.PATH_SRM,
                PATH_ROUTING.PATH_ADMIN,
                PATH_ROUTING.PATH_INTERNAL_USER,
              ]);
            } else {
              this.toastr.success(MESSAGE_TOAST.EDIT_SUPPLIER_SUCCESS);
              this.router.navigate([
                PATH_ROUTING.PATH_SRM,
                PATH_ROUTING.PATH_ADMIN,
                PATH_ROUTING.PATH_SUPPIER_USER,
              ]);
            }
          }
        });
    }
  }

  public search() {
    this.spinner.show();
    this.userSupplierService
      .checkSSO(this.supplierForm.controls.sso.value, this.type)
      .subscribe((res) => {
        this.spinner.hide();
        if (res.data.length > 0) {
          this.supplierForm.controls.fullName.setValue(res.data[0].fullName);
          this.supplierForm.controls.email.setValue(res.data[0].email);
        } else {
          this.toastr.error(MESSAGE_TOAST.SSO_NOT_FOUND);
          this.supplierForm.controls.sso.setValue("");
          this.supplierForm.controls.fullName.setValue("");
          this.supplierForm.controls.email.setValue("");
          this.supplierForm.controls.rspAccess.setValue(false);
        }
      });
  }

  public addNew() {
    this.listInfo.push(new GSLModel("", "", "", true));
  }

  public addNewEOL() {
    this.listEOLInfo.push(new EOLModel("", "", "", true));
  }

  public deleteItem(index) {
    this.listInfo.splice(index, 1);
  }

  public deleteEOLItem(index) {
    this.listEOLInfo.splice(index, 1);
  }

  private markFormGroupTouched(formGroup: FormGroup): void {
    (Object as any).values(formGroup.controls).forEach((control) => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  private checkRequiredGSLInfo(data: any[]) {
    let flag = false;
    if (data.length > 0) {
      data.forEach((item: GSLModel) => {
        if (!item.gslNumber.trim() || !item.supplierName.trim()) {
          flag = true;
        }
      });
      return flag;
    }
  }

  private checkRequiredEOLInfo(data: any[]) {
    let flag = false;
    if (data.length > 0) {
      data.forEach((item: EOLModel) => {
        if (!item.gslNumber.trim() || !item.supplierName.trim()) {
          flag = true;
        }
      });
      return flag;
    }
  }

  public checkDuplicateGSLInfo(data: any[]) {
    let flag = false;
    data.forEach((item1: GSLModel, index1) => {
      data.forEach((item2: GSLModel, index2) => {
        if (index2 > index1) {
          if (
            item1.gslNumber.toLowerCase() === item2.gslNumber.toLowerCase() &&
            item1.supplierName.toLowerCase() ===
              item2.supplierName.toLowerCase()
          ) {
            flag = true;
          }
        }
      });
    });
    return flag;
  }

  public checkDuplicateEOLInfo(data: any[]) {
    let flag = false;
    data.forEach((item1: EOLModel, index1) => {
      data.forEach((item2: EOLModel, index2) => {
        if (index2 > index1) {
          if (
            item1.gslNumber.toLowerCase() === item2.gslNumber.toLowerCase() &&
            item1.supplierName.toLowerCase() ===
              item2.supplierName.toLowerCase()
          ) {
            flag = true;
          }
        }
      });
    });
    return flag;
  }

  public checkDifferentParentCompantName(data: any[]) {
    let flag = false;
    data.forEach((item1: GSLModel, index1) => {
      data.forEach((item2: GSLModel, index2) => {
        if (index2 > index1) {
          if (
            item1.parentCompanyName.toLowerCase() !==
            item2.parentCompanyName.toLowerCase()
          ) {
            flag = true;
          }
        }
      });
    });
    return flag;
  }

  public checkDifferentSupplierType(data: any[]) {
    let flag = false;
    data.forEach((item1: EOLModel, index1) => {
      data.forEach((item2: EOLModel, index2) => {
        if (index2 > index1) {
          if (
            item1.supplierType.toLowerCase() !==
            item2.supplierType.toLowerCase()
          ) {
            flag = true;
          }
        }
      });
    });
    return flag;
  }

  public getSupplierById(type, id) {
    this.spinner.show();
    this.userSupplierService.getSupplierByTypeAndId(type, id).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.data && res.status === 200) {
          this.supplierModel = res.data;
          this.initForm(this.supplierModel);
          this.listInfo = res.data.gslInfos.map((item) => {
            item.isEdit = false;
            return item;
          });
          this.listEOLInfo = (res.data.eolInfos || []).map((item) => {
            const sf = item?.supplierForm || {};
            item.isEdit = false;
            item.supplierForm = sf;
            item.gslNumber = sf.supplierGsl || "";
            item.supplierName = sf.supplierName || "";
            item.destruction = this.mapToOption(sf.destruction);
            item.recycling = this.mapToOption(sf.recycling);
            return item;
          });
          if (this.listEOLInfo.length === 0) {
            this.listEOLInfo.push(new EOLModel("", "", "", true));
          }
        }
      },
      (err) => {
        this.router.navigate([
          PATH_ROUTING.PATH_SRM,
          PATH_ROUTING.PATH_ADMIN,
          PATH_ROUTING.PATH_SUPPIER_USER,
        ]);
      },
    );
  }

  public getGSLData(value, name) {
    if (!value) {
      this.listGSLNumber = [];
      this.listSupplierName = [];
      this.listParentCompanyName = [];
      return;
    }
    this.userSupplierService
      .getGSLInfoByType(name, value, this.type)
      .subscribe((res) => {
        if (res.data.length > 0) {
          this.gslInfo = res.data.map((item) => {
            const object = {
              name:
                name === "supplierName"
                  ? item.supplierName + " - " + item.gslNumber
                  : name === "parentCompanyName"
                    ? item.parentCompanyName +
                      " - " +
                      item.supplierName +
                      " - " +
                      item.gslNumber
                    : item[name],
              gslNumber: item.gslNumber,
              parentCompanyName: item.parentCompanyName,
              supplierName: item.supplierName,
              id: item.id,
            };
            return object;
          });
        } else {
          this.gslInfo = [];
        }
        if (name === GSL_INFO.GSL_NUMBER) {
          this.listGSLNumber = this.gslInfo;
        } else if (name === GSL_INFO.SUPPLIER_NAME) {
          this.listSupplierName = this.gslInfo;
        } else {
          this.listParentCompanyName = this.gslInfo;
        }
      });
  }

  public getEOLData(value, name) {
    const queryName = name === "supplierType" ? "parentCompanyName" : name;
    if (!value) {
      this.listEOLGSLNumber = [];
      this.listEOLSupplierName = [];
      this.listSupplierType = [];
      return;
    }
    this.userSupplierService
      .getGSLInfoByType(queryName, value, this.type)
      .subscribe((res) => {
        if (res.data.length > 0) {
          this.eolInfo = res.data.map((item) => {
            const supplierType = item.supplierType || item.parentCompanyName;
            const object = {
              name:
                name === "supplierName"
                  ? item.supplierName + " - " + item.gslNumber
                  : name === "supplierType"
                    ? supplierType +
                      " - " +
                      item.supplierName +
                      " - " +
                      item.gslNumber
                    : item[name],
              gslNumber: item.gslNumber,
              supplierType,
              supplierName: item.supplierName,
              id: item.id,
            };
            return object;
          });
        } else {
          this.eolInfo = [];
        }
        if (name === GSL_INFO.GSL_NUMBER) {
          this.listEOLGSLNumber = this.eolInfo;
        } else if (name === GSL_INFO.SUPPLIER_NAME) {
          this.listEOLSupplierName = this.eolInfo;
        } else {
          this.listSupplierType = this.eolInfo;
        }
      });
  }

  public setAutoComplete(value, name, index) {
    const gslObject = this.gslInfo.filter((item) => item.name === value);
    this.listInfo[index][name] = "";
    if (gslObject.length > 0) {
      setTimeout(() => {
        this.listInfo[index].gslNumber = gslObject[0].gslNumber;
        this.listInfo[index].parentCompanyName = gslObject[0].parentCompanyName;
        this.listInfo[index].supplierName = gslObject[0].supplierName;
        this.listInfo[index].isEdit = false;
      });
    }
  }

  public setEOLAutoComplete(value, name, index) {
    const eolObject = this.eolInfo.filter((item) => item.name === value);
    this.listEOLInfo[index][name] = "";
    if (eolObject.length > 0) {
      setTimeout(() => {
        this.listEOLInfo[index].gslNumber = eolObject[0].gslNumber;
        this.listEOLInfo[index].supplierType = eolObject[0].supplierType;
        this.listEOLInfo[index].supplierName = eolObject[0].supplierName;
        this.listEOLInfo[index].isEdit = false;
      });
    }
  }

  public setManual(event, name, index) {
    this.listInfo[index][name] = event;
  }

  public setManualEOL(event, name, index) {
    this.listEOLInfo[index][name] = event;
    if (name === "gslNumber") {
      this.fetchEOLSupplierNames(event, index, true);
    }
  }

  public onEOLGslChange(value: string, index: number) {
    this.fetchEOLSupplierNames(value, index);
  }

  private fetchEOLSupplierNames(gslNumber: string, index: number, resetDependents = false) {
    if (resetDependents) {
      this.listEOLInfo[index].supplierName = "";
      this.listEOLInfo[index].supplierForm = null;
      this.listEOLInfo[index].destruction = "";
      this.listEOLInfo[index].recycling = "";
      this.eolSupplierNameOptions = [];
      this.eolSupplierData = [];
    }
    if (!gslNumber || !gslNumber.trim()) {
      return;
    }
    const requestOption = {
      pagingOptions: { size: 100, number: 0, sort: null },
    };
    this.srmService
      .getSupplierDataTable(requestOption, null, gslNumber)
      .subscribe((res) => {
        const content: any[] =
          res?.data?.content || (Array.isArray(res?.data) ? res.data : []);
        this.eolSupplierData = content;
        this.eolSupplierNameOptions = content
          .map((item) => item.supplierName)
          .filter((name) => !!name);
      });
  }

  public onEOLSupplierNameChange(value: string, index: number) {
    this.listEOLInfo[index].supplierName = value;
    const matched = this.eolSupplierData.find(
      (item) => item && item.supplierName === value,
    );
    if (!matched) {
      this.listEOLInfo[index].supplierForm = null;
      this.listEOLInfo[index].destruction = "";
      this.listEOLInfo[index].recycling = "";
      return;
    }
    this.listEOLInfo[index].gslNumber = matched?.supplierGsl;
    this.listEOLInfo[index].supplierForm = matched;
    this.listEOLInfo[index].destruction = this.mapToOption(matched.destruction);
    this.listEOLInfo[index].recycling = this.mapToOption(matched.recycling);
  }

  private mapToOption(value: any): string {
    if (value === true || value === "true") {
      return "Yes";
    }
    if (value === false || value === "false") {
      return "No";
    }
    return "";
  }
}
